import { UseQueryResult } from '@tanstack/react-query';
import React from 'react';
import { IProduct } from 'src/interfaces';

export function useOverflowHelper(
  elementRef: React.RefObject<HTMLElement>,
  dependencies: (
    | string
    | number
    | React.ReactNode
    | UseQueryResult<IProduct, unknown>
    | undefined
  )[] = [],
) {
  const [overflow, setOverflow] = React.useState<boolean>(false);

  React.useEffect(() => {
    const element = elementRef.current;
    if (element === null) return;

    setOverflow(
      element.offsetHeight < element.scrollHeight ||
        element.offsetWidth < element.scrollWidth,
    );
  }, [elementRef.current, ...dependencies]); // eslint-disable-line

  return overflow;
}

export function useTagOverflowHelper(
  elementName: string,
  elementNumber: number,
  elementRef: React.RefObject<HTMLElement>,
  dependencies: (string | undefined)[] = [],
) {
  const [overflow, setOverflow] = React.useState<boolean>(false);

  React.useEffect(() => {
    const element = elementRef.current?.getElementsByTagName(elementName)[
      elementNumber
    ] as HTMLElement | undefined;

    if (element === null || element === undefined) return;

    setOverflow(
      element.offsetHeight < element.scrollHeight ||
        element.offsetWidth < element.scrollWidth,
    );
  }, [elementRef.current, ...dependencies]); // eslint-disable-line

  return overflow;
}
